module.exports = __webpack_public_path__ + "img/bend_debit_card_2x.726ab8b3.svg";